import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="ml-64 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Company Info */}
          <div className="flex items-center space-x-4">
            <span className="text-gray-900 dark:text-white font-semibold">
              DSD Systems Pvt. Ltd.
            </span>
            <span className="text-gray-500 dark:text-gray-400">|</span>
            <a 
              href="https://dsdspl.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition-colors duration-200"
            >
              dsdspl.com
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} All rights reserved
          </div>

          {/* Quick Links */}
          <div className="flex space-x-6">
            <Link 
              to="/privacy" 
              className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
            >
              Privacy
            </Link>
            <Link 
              to="/terms" 
              className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
            >
              Terms
            </Link>
            <a 
              href="mailto:contact@dsdspl.com" 
              className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
} 